
//var _baseUrl = 'http://qdqtrserver01.qatarcentral.cloudapp.azure.com:8081/QdHealth_Api'
//var _baseUrl = 'https://qdtestserver01.eastus2.cloudapp.azure.com:401/WEBHIS_API'
// var _baseUrl='http://qddemoserver.eastus.cloudapp.azure.com:84/QdHealth_Api'
// var _baseUrl =  'http://localhost:3833' 
var _baseUrl='http://dev1.solver-erp.com:200/QdHealth_Api'
//var _baseUrl='https://gamconline.qdhealth.net:464/Qdhealth_Api'
//var _baseUrl = 'https://nmc.qdhealth.net:406/QdHealth_Api'
export const environment = {
  production: false,
  appId: "16704a4cfe3de97",
  apiKey: "b3c243e67d2e0f7e8db400e99e05d3d6c049c9ba",
  region: 'EU',
  QdVChatBaseUrl: `https://api-eu.cometchat.io/v2.0/`,
  apiBaseUrl: `${_baseUrl}/Api/`,
  QdIpfetchToken: '523d5c55ff89ea',
  DocumentUploadBaseUrl: '',
  ImageBaseUri: `${_baseUrl}/Uploads/`,
  webSite: `https://nmcoman.com`
};
